import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { Label, Segment } from 'semantic-ui-react'
import { tr } from '../../helpers/languages'
import Participant from './participant'

class TodayParticipants extends Component {
    constructor (props) {
        super(props)
        const contains = props.selectedParticipant && props.participants.some((participant) => {
            return participant.id === props.selectedParticipant
        })
        this.ref = contains ? React.createRef() : undefined
        autoBind(this)
    }

    componentDidMount () {
        if (this.ref && this.ref.current) this.ref.current.scrollIntoView()
    }

    componentDidUpdate () {
        if (this.ref && this.ref.current) this.ref.current.scrollIntoView()
    }

    render() {
        return (
            <Segment
                className='today'
                style={{
                    flex: this.props.flex,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto'
                }}
            >
                <Segment className='counter'>
                    {tr('TODAY_SESSIONS')} <Label>({this.props.participants.length})</Label>
                </Segment>
                <Segment
                    className='today-participants'
                    style={{flex: 1, minHeight: 0, overflowY: 'auto'}}
                >
                    {this.props.participants.map((p, index) => (
                        <Participant
                            key={`participant${p.id}`}
                            participant={p}
                            today
                            last={index === this.props.participants.length - 1}
                            selected={this.props.selectedParticipant === p.id}
                            timezone={this.props.timezone}
                            language={this.props.language}
                            onSelectParticipant={this.props.onSelectParticipant}
                        />
                    ))}
                </Segment>
            </Segment>
        )
    }
}

export default TodayParticipants



// WEBPACK FOOTER //
// ./src/components/participants/today-participants.js